const initHeaderScroll = () => {
  const header = document.querySelector(".header");
  if (!header) return;

  const scrollThreshold = 100;

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > scrollThreshold) {
      header.classList.add("header--scroll");
    } else {
      header.classList.remove("header--scroll");
    }
  };

  // Throttle scroll event for better performance
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Initial check
  handleScroll();
};

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeaderScroll);
} else {
  initHeaderScroll();
}

export default initHeaderScroll;
